import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { mergeMap, map, catchError, delay } from 'rxjs/operators';
import { of } from 'rxjs';
import * as accUsr from '../actions/usuario.actions';
import { AuthService } from 'src/app/services/auth/auth.service';
import { NotificacionesService } from 'src/app/services/notificaciones.service';
import { ExpedientesService } from 'src/app/services/expedientes.service';

@Injectable()
export class UsuarioEffects {

    constructor(
        private actions$: Actions,
        private authService: AuthService,
        private notiService: NotificacionesService,
        private expedientesSV: ExpedientesService,
        // private store: Store<AppState>
    ) { }


    datosUsuario$ = createEffect(
        () => this.actions$.pipe(
            ofType(accUsr.solicitarDatosUsuarioAcc),
            mergeMap((eff) => {
                sessionStorage.setItem('IES-IN', 'Si');
                return this.authService.obtenerDatosUsuario()
                .pipe(
                    map((rspUsr: { data }) => {
                        return accUsr.obtenerUsuarioSuccessAcc({ Usuario: rspUsr.data })
                    }),catchError(err => {
                        const errorMessage = err?.message || 'Tu sesión ha expirado';
                        this.authService.cerrarSesion();
                        this.notiService.snackbarError(errorMessage, 'X');
                        accUsr.obtenerUsuarioErrorAcc({ payload: err });
                        this.notiService.cambiarEstatusLoader('Desactivar');
                        return of(accUsr.resetDatosUsuarioAcc()).pipe(delay(500));
                    }
            ))})
        )
    );
}